import Add from './component'

export default Add